/**
 *  Locations state module file
**/
const DEFAULT_META = {
  loading: false,
  count: 0,
  page: 1,
  page_size: 50
}

export const getDefaultState = () => ({
  viewportFilter: {
    enabled: false,
    shops: [],
    adverts: [],
    pois: [],
    zones: []
  },
  shops: {
    query: null,
    meta: { ...DEFAULT_META, name: 'Centro' },
    data: []
  },
  adverts: {
    query: null,
    meta: { ...DEFAULT_META, name: 'Soporte' },
    data: []
  },
  groups: {
    meta: { ...DEFAULT_META, name: 'Grupo' },
    data: []
  },
  pois: {
    query: null,
    meta: { ...DEFAULT_META, name: 'POI' },
    data: []
  },
  shops_summary: {
    query: null,
    meta: { ...DEFAULT_META, name: 'Centro' },
    data: []
  },
  adverts_summary: {
    query: null,
    meta: { ...DEFAULT_META, name: 'Soporte' },
    data: []
  },
  pois_summary: {
    query: null,
    meta: { ...DEFAULT_META, name: 'POI' },
    data: []
  },
  zones: {
    query: null,
    meta: { ...DEFAULT_META, name: 'Código postal' },
    data: []
  },
  grids: {
    query: null,
    meta: { ...DEFAULT_META, name: 'Grids' },
    data: []
  }
})

export const state = getDefaultState()
